<script lang="ts" setup>
import { computed } from "vue";
import { useAppStore } from "@/store/app.store";

const props = withDefaults(
  defineProps<{
    bookedBy: number;
    orderId: string;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const appStore = useAppStore();

const dispatcherName = computed(() => {
  return appStore.dispatchers.find((dispatcher) => dispatcher.id === props.bookedBy)?.name;
});

const textDisabledClass = computed(() => {
  return {
    "text-grey": props.disabled,
  };
});
</script>

<template>
  <div v-if="dispatcherName" :class="textDisabledClass" class="d-flex text-grey-darken-1 ml-6" data-qa="booked-by">
    <span>Booked by:</span>

    <span
      :class="{
        'text-primary': !props.disabled,
      }"
      class="ml-1"
    >
      {{ dispatcherName }}
    </span>
  </div>
</template>

<style lang="scss" scoped></style>
